import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { translate } from '@lucidlink/uicore';
import { DEPENDENCY_KEYS, } from '@lucidlink/workspacemanagement';
import { DownloadDesktopAppLink, ExitAppFlow, LogoutFlow, LucidlinkClassicLink, SupportMenu, } from '#components';
import { useLoginEmail, useLoginPassword, useLoginSsoKey, useLoginWorkspaceName, useStartSsoAuthentication, WorkspaceSSOAuthentication, } from '#features/auth';
import { BillingMenuItem, BillingPlansLink, WorkspaceLimitNavToBilling, WorkspaceSettingsSidebarBillingMenuItem, WorkspaceSuspendedNavToBilling, } from '#features/billing';
import { DirectLink, FilespaceCard, FilespaceDashboard, FilespaceListItem, FilespaceSettings, restrictedFilespacePredicate, UploadYourFirstFilesAction, useFilespaceQuit, useFilespaceSettingsToasts, useFilespaceSnapshots, useFilespaceUpgradeNotifier, useGetGlobalSettings, useSetGlobalSettings, useSetGlobalTeamCache, useUnsetGlobalSettings, } from '#features/filespaces';
import { useGuestLinkGoToFolder } from '#features/guest-links';
import { UserMenuGoToManagementPlatformOption } from '#features/management-platform';
import { getAdditionalInfo } from '#services';
export const dependencies = {
    // Aux
    [DEPENDENCY_KEYS.CLIENT_BASE_URL]: window.location
        .origin,
    [DEPENDENCY_KEYS.WEB_SERVICE_ENDPOINT]: process.env.WEB_SERVICE_ENDPOINT,
    [DEPENDENCY_KEYS.DEFAULT_ROUTE]: '/home',
    // Components
    [DEPENDENCY_KEYS.BillingMenuItem]: BillingMenuItem,
    [DEPENDENCY_KEYS.BillingPlansLink]: BillingPlansLink,
    [DEPENDENCY_KEYS.DiagnosticReportFlow]: () => null,
    [DEPENDENCY_KEYS.DirectLink]: DirectLink,
    [DEPENDENCY_KEYS.DownloadDesktopAppLink]: DownloadDesktopAppLink,
    [DEPENDENCY_KEYS.ExitAppFlow]: ExitAppFlow,
    [DEPENDENCY_KEYS.FilespaceDashboard]: FilespaceDashboard,
    [DEPENDENCY_KEYS.FilespaceMigration]: () => _jsx(Navigate, { to: "/" }),
    [DEPENDENCY_KEYS.FilespaceCard]: FilespaceCard,
    [DEPENDENCY_KEYS.FilespaceFooter]: () => null,
    [DEPENDENCY_KEYS.FilespaceListItem]: FilespaceListItem,
    [DEPENDENCY_KEYS.FilespaceSettings]: FilespaceSettings,
    [DEPENDENCY_KEYS.LogoutFlow]: LogoutFlow,
    [DEPENDENCY_KEYS.LucidlinkClassicLink]: LucidlinkClassicLink,
    [DEPENDENCY_KEYS.NoWorkspacesFsMigrateLink]: () => null,
    [DEPENDENCY_KEYS.NoWorkspacesChannelPartnerMigrateLink]: () => null,
    [DEPENDENCY_KEYS.PinningFlow]: () => null,
    [DEPENDENCY_KEYS.SupportMenu]: SupportMenu,
    [DEPENDENCY_KEYS.UploadYourFirstFilesAction]: UploadYourFirstFilesAction,
    [DEPENDENCY_KEYS.UserMenuExitAppOption]: () => null,
    [DEPENDENCY_KEYS.UserMenuGoToManagementPlatformOption]: UserMenuGoToManagementPlatformOption,
    [DEPENDENCY_KEYS.UserMenuMigrateChannelPartnerFilespaceOption]: () => null,
    [DEPENDENCY_KEYS.UserMenuMigrateFilespaceOption]: () => null,
    [DEPENDENCY_KEYS.WorkspaceLimitNavToBilling]: WorkspaceLimitNavToBilling,
    [DEPENDENCY_KEYS.WorkspaceSettingsSidebarBillingMenuItem]: WorkspaceSettingsSidebarBillingMenuItem,
    [DEPENDENCY_KEYS.WorkspaceSSOAuthentication]: WorkspaceSSOAuthentication,
    [DEPENDENCY_KEYS.WorkspaceSuspendedNavToBilling]: WorkspaceSuspendedNavToBilling,
    // Hooks
    // The browser has no file explorer to open, so it offers no way to open one.
    [DEPENDENCY_KEYS.UseFilespaceOpenInFileExplorer]: () => null,
    [DEPENDENCY_KEYS.UseFilespaceQuit]: useFilespaceQuit,
    [DEPENDENCY_KEYS.UseFilespaceSnapshots]: useFilespaceSnapshots,
    [DEPENDENCY_KEYS.UseGuestLinkGoToFolder]: useGuestLinkGoToFolder,
    [DEPENDENCY_KEYS.UseNotificationMessages]: () => { },
    [DEPENDENCY_KEYS.UseOnCurrentUserChange]: () => { },
    [DEPENDENCY_KEYS.UseReconnectFilespaces]: () => { },
    [DEPENDENCY_KEYS.UseFilespacesDisconnectOnNoAccess]: () => { },
    [DEPENDENCY_KEYS.UseFilespaceUpgradeNotifier]: useFilespaceUpgradeNotifier,
    //Login flow hooks
    [DEPENDENCY_KEYS.UseLoginEmail]: useLoginEmail,
    [DEPENDENCY_KEYS.UseLoginPassword]: useLoginPassword,
    [DEPENDENCY_KEYS.UseLoginSsoKey]: useLoginSsoKey,
    [DEPENDENCY_KEYS.UseLoginWorkspaceName]: useLoginWorkspaceName,
    [DEPENDENCY_KEYS.UseStartSsoAuthentication]: useStartSsoAuthentication,
    // Filespace Settings
    [DEPENDENCY_KEYS.FilespaceReconnect]: () => null,
    // Hooks
    [DEPENDENCY_KEYS.UseHandleMissingCacheLocation]: () => { },
    [DEPENDENCY_KEYS.UseFilespaceSettingsToasts]: useFilespaceSettingsToasts,
    [DEPENDENCY_KEYS.UseOnMountPointReset]: () => null,
    // Global
    [DEPENDENCY_KEYS.UseGetGlobalSettings]: useGetGlobalSettings,
    [DEPENDENCY_KEYS.UseSetGlobalSettings]: useSetGlobalSettings,
    [DEPENDENCY_KEYS.UseSetGlobalTeamCache]: useSetGlobalTeamCache,
    [DEPENDENCY_KEYS.UseUnsetGlobalSettings]: useUnsetGlobalSettings,
    // Functions
    [DEPENDENCY_KEYS.RestrictedFilespacePredicate]: restrictedFilespacePredicate,
    [DEPENDENCY_KEYS.GetAdditionalInfo]: getAdditionalInfo,
    // Plain texts
    [DEPENDENCY_KEYS.ServiceUnavailableViewMessage]: () => translate("Our servers are temporarily unavailable. We're working hard to get your workspace back online as quickly as possible"),
};
